// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { customNormalFormat } = require('utilities/dateHelper');

// @ constants
const { DATE_FORMAT_ES, DATE_FORMAT_EN } = require('../../../insuranceConstants/insuranceRequestHome');
const { FOURTH_STEP } = require('constants/index');

const insuranceRequestBuildStartDate = (immInsuranceWizardState) => {
    const dateFormat = getLanguage() === 'es' ? DATE_FORMAT_ES : DATE_FORMAT_EN;
    const text = customNormalFormat(immInsuranceWizardState.getIn(['steps', FOURTH_STEP, 'startDate']), dateFormat)
    const starDate = {
        text,
        label: formatText('insuranceRequestHome-step5StartDate')
    };
    return starDate;
}

module.exports = insuranceRequestBuildStartDate;